import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivityService } from '../shared/activity.service';
import { ProgramGroupService } from '../shared/program-group.service';
import { Router } from '@angular/router';
import { AuthService, User } from '../shared/auth.service';
import { Observable, Subscription } from 'rxjs';


@Component({
  selector: 'app-activity-list',
  templateUrl: './activity-list.component.html',
  styleUrls: ['./activity-list.component.css']
})
export class ActivityListComponent implements OnInit, OnDestroy {
  activities;
  activityData = {};
  selectedProgramGroup;
  displayedColumns = ['councilId', 'activityType', 'activityStatus'];
  user: Observable<User>;
  isAdmin = false;
  isGeneralProgramDirector = false;
  programGroupDisplayName = '';

  private subscriptions = new Subscription();

  constructor(private activityService: ActivityService,
              private programGroupService: ProgramGroupService,
              private authService: AuthService,
              private router: Router) {
    this.user = this.authService.getUser();
  }

  ngOnInit() {
    this.subscriptions.add(this.user.subscribe(user => {
      if (user) {
        const activitiesForUser = this.activityService.getActivitiesForUser(user);
        if (activitiesForUser != null) {
          this.subscriptions.add(activitiesForUser.subscribe(res => this.activities = res.map(a => {
            this.subscriptions.add(this.activityService.getActivityData(a.payload.doc.id).subscribe(activityDataRes => {
              this.activityData[a.payload.doc.id] = {...activityDataRes.payload.data() as {} };
            }));
            return {...a.payload.doc.data() as {}, id: a.payload.doc.id};
          })));
        } else {
          this.activities = null;
        }
        this.isAdmin = user.roles.admin;
        this.isGeneralProgramDirector = user.roles.generalProgramDirector;

        if (user.roles.communityDirector) {
          this.programGroupDisplayName = 'Community';
        } else if (user.roles.faithDirector) {
          this.programGroupDisplayName = 'Faith';
        } else if (user.roles.familyDirector) {
          this.programGroupDisplayName = 'Family';
        } else if (user.roles.lifeDirector) {
          this.programGroupDisplayName = 'Life';
        } else if (user.roles.membershipDirector) {
          this.programGroupDisplayName = 'Membership';
        } else {
          this.programGroupDisplayName = '';
        }
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getProgramGroups() {
    return this.programGroupService.getProgramGroups();
  }

  getActivityNameById(activityTypeId: string): string {
    return this.programGroupService.getActivityNameById(activityTypeId);
  }

  programGroupSelected() {

  }

  activitySelected(activity) {
    this.router.navigate(['grade-activity', activity.id]);
  }

  getActivityStatus(activity) {
    if (activity && this.activityData[activity.id]) {
      return this.activityData[activity.id].activityStatus;
    }
    return '';
  }
}
